import React from 'react';
import NumberFormatter from '../../../app/formatters/NumberFormatter';

export default function CashregisterProduct({ product, paramStock, paramShowimages, onClickOnProduct }) {
  var style = paramShowimages
      ? {
          backgroundImage: `url(${product.thumbnail || '/images/NO_THUMBNAIL.webp'})`
        }
      : {},
    className = 'cashregister__line';

  className += paramStock && !product.unlimited_stock && product.stock <= 0 ? ' cashregister__line--no-stock' : ' cashregister__line--stock';

  return (
    <a className="cashregister__product cashregister__product--no-padding" href="#" onClick={onClickOnProduct}>
      <div className="cashregister__product-image" style={style}></div>
      <div className="cashregister__padding">
        <h5 className="cashregister__card-name">{product.name}</h5>
        <div className="cashregister__line">{NumberFormatter.formatNumber(product.ttc_price)}</div>
        {!product.unlimited_stock ? <div className={className}>(Stock. : {product.stock})</div> : ''}
      </div>
    </a>
  );
}
